export default [
  {
    path: '/admin/projects-event-logs',
    name: 'ProjectsEventLogs',
    component: () => import('@/views/Admin/Projects_event_logs/Index.vue'),
    meta: {
      pageTitle: 'Proje Aktiviteleri',
      breadcrumb: [
        {
          text: 'Listele',
          active: true,
        },
      ],
      resource: 'ADMN_PROJECTS_EVENT_LOGS',
      action: 'read',
    },
  },
  {
    path: '/admin/projects-event-logs/view/:id',
    name: 'ProjectsEventLogEdit',
    component: () => import('@/views/Admin/Projects_event_logs/View.vue'),
    meta: {
      pageTitle: 'Proje Aktiviteleri',
      breadcrumb: [
        {
          text: 'Listele',
          to: '/admin/projects-event-logs',
          active: false,
        },
        {
          text: 'Görüntüle',
          active: true,
        },
      ],
      resource: 'ADMN_PROJECTS_EVENT_LOGS_VIEW',
      action: 'read',
    },
  },
]
